<template>
  <authorization
    permissionKey="attendance_treatment"
    can="save"
    v-slot:default="{ authorization }"
  >
    <v-container fluid v-if="authorization">
      <v-row>
        <v-col class="text-h3 gray--text">
          Tratamentos
        </v-col>

        <v-col cols="auto">
          <v-btn color="gray lighten-1" dark :to="`/prontuario/${attendance.id}/tratamentos`">
            voltar
          </v-btn>
        </v-col>
      </v-row>

      <TreatmentForm
        :attendance="attendance"
        :treatment="treatment"
        :disabled="attendanceEsigned"
        v-if="treatment"
      />
    </v-container>
  </authorization>
</template>

<script>
  import TreatmentForm from "@/components/treatment/form.vue";

  export default {
    name: "treatment",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
      treatmentId: String,
    },
    components: {
      TreatmentForm,
    },
    apollo: {
      treatment: {
        query: require("@/graphql/treatment/treatment.gql"),
        fetchPolicy: "no-cache",
        variables() {
          return {
            treatmentId: this.treatmentId,
          };
        },
      },
    },
  };
</script>

<style lang="scss" scoped></style>
